import React, { useState } from 'react';
import { TextField, Button, Box, Typography, Alert, CircularProgress } from '@mui/material';
import axios from 'axios';
import { useNavigate, Link } from 'react-router-dom';

const Login = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({ email: '', password: '' });
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError(null);
    
    try {
      const response = await axios.post('https://doc-365-production.up.railway.app/api/login', formData);
      localStorage.setItem('token', response.data.token);

      navigate("/");
    } catch (err) {
      if (err.response && err.response.status === 403) {
        setError("El usuario está en pendiente");
      } else if (err.response && err.response.status === 404) {
        setError("Usuario no encontrado");
      } else {
        setError("Ocurrió un error inesperado");
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Box
      component="form"
      onSubmit={handleSubmit}
      sx={{
        maxWidth: 400,
        mx: 'auto',
        mt: 5,
        p: 3,
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
        borderRadius: 2,
      }}
    >
      <Box
        component="img"
        src={require("../../assets/Images/rect4-3-2.png")}
        alt="Logo"
        sx={{
          width: 200,
          mx: 'auto',
          mb: 2,
          p: 2,
          marginTop: "3em",
          borderRadius: "5px",
        }}
      />
      <Typography variant="h5" align="center" gutterBottom>
        Iniciar Sesión
      </Typography>
      {error && (
        <Alert severity="error" onClose={() => setError(null)}>
          {error}
        </Alert>
      )}
      <TextField
        label="Correo Electrónico"
        name="email"
        type="email"
        value={formData.email}
        onChange={handleChange}
        required
        fullWidth
        sx={{
          "& .MuiOutlinedInput-root": {
            "&:hover fieldset": {
              borderColor: "#4d2c8d",
            },
            "&.Mui-focused fieldset": {
              borderColor: "#4d2c8d",
            },
          },
          "& .MuiInputLabel-root": {
            color: "#000",
          },
          "& .MuiInputLabel-root.Mui-focused": {
            color: "#4d2c8d",
          },
        }}
      />
      <TextField
        label="Contraseña"
        name="password"
        type="password"
        value={formData.password}
        onChange={handleChange}
        required
        fullWidth
        sx={{
          "& .MuiOutlinedInput-root": {
            "&:hover fieldset": {
              borderColor: "#4d2c8d",
            },
            "&.Mui-focused fieldset": {
              borderColor: "#4d2c8d",
            },
          },
          "& .MuiInputLabel-root": {
            color: "#000",
          },
          "& .MuiInputLabel-root.Mui-focused": {
            color: "#4d2c8d",
          },
        }}
      />
      <Button
        type="submit"
        variant="contained"
        color="primary"
        fullWidth
        disabled={isLoading}
        sx={{ backgroundColor: "#4d2c8d", ":hover": { backgroundColor: "#4d2c8d" } }}
      >
        {isLoading ? <CircularProgress size={24} color="inherit" /> : 'Ingresar'}
      </Button>
      <Typography variant="body2" align="center" sx={{ mt: 2 }}>
        ¿No tienes una cuenta?{' '}
        <Link to="/registrar-usuario" style={{ color: '#4d2c8d', textDecoration: 'none', fontWeight: 'bold' }}>
          Regístrate aquí
        </Link>
      </Typography>
    </Box>
  );
};

export default Login;
